module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/userIcon-c2295e97034c3249ecfd1267ad02cc0e.png";